import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-setting"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.75 18.75C21.75 20.4069 20.4069 21.75 18.75 21.75C17.0931 21.75 15.75 20.4069 15.75 18.75C15.75 17.0931 17.0931 15.75 18.75 15.75C20.4069 15.75 21.75 17.0931 21.75 18.75Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 6V4H4V22H11M8 6H16M8 6V2H16V6M16 6V4H20V11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.7509 15.75V14.5M18.7509 15.75C17.0941 15.75 15.7509 17.0931 15.7509 18.75C15.7509 20.4069 17.0941 21.75 18.7509 21.75M18.7509 15.75C20.4078 15.75 21.7509 17.0931 21.7509 18.75C21.7509 20.4069 20.4078 21.75 18.7509 21.75M18.7509 21.75V23M16.1528 17.25L15.0703 16.625M21.349 20.25L22.4315 20.875M21.349 17.25L22.4315 16.625M16.1528 20.25L15.0703 20.875","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskSetting = Vue.extend<IconProps>({
  name: 'TaskSettingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'task-setting',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TaskSetting;
